export default function Hero() {
  const meta = [
    ["// Est.", "2004"],
    ["// Projects", "500+"],
    ["// Sectors", "Gov · Pvt"],
  ];

  return (
    <section style={{ borderBottom: "1px solid var(--ink)" }}>
      <div
        className="hero-grid"
        style={{ display: "grid", gridTemplateColumns: "1fr 1fr", minHeight: "680px" }}
      >
        {/* Left column */}
        <div
          className="hero-left"
          style={{ padding: "80px 40px 40px 32px", display: "flex", flexDirection: "column", justifyContent: "space-between", borderRight: "1px solid var(--ink)" }}
        >
          <div>
            <h1 style={{ fontSize: "clamp(44px, 5.5vw, 84px)", lineHeight: 0.92, letterSpacing: "-0.035em", fontWeight: 500 }}>
              <span style={{ color: "var(--blue)", fontWeight: 400 }}>Aluminium</span>,<br />
              cladding &amp; glass,<br />
              built to outlast<br />
              the building.
            </h1>
            <p style={{ fontSize: "16px", maxWidth: "44ch", color: "#2b2b2b", marginTop: "28px", lineHeight: 1.5 }}>
              22 years of aluminium construction, cladding, partitions and glasswork for government and private sector projects across Sri Lanka.
            </p>
            <div style={{ display: "flex", gap: "12px", marginTop: "36px", flexWrap: "wrap" }}>
              <a href="#work" className="btn">View selected work →</a>
              <a href="#contact" className="btn btn-ghost">Request quote</a>
            </div>
          </div>

          {/* Metadata row */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", borderTop: "1px solid var(--ink)", marginTop: "48px" }}>
            {meta.map(([k, v], i) => (
              <div
                key={k}
                style={{ paddingTop: "20px", paddingBottom: "4px", paddingLeft: "16px", paddingRight: "16px", borderLeft: i === 0 ? "1px dashed rgba(10,10,10,0.2)" : "none", borderRight: i < 3 ? "1px dashed rgba(10,10,10,0.2)" : "none" }}
              >
                <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "10px", letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--muted)" }}>{k}</div>
                <div style={{ fontSize: "34px", fontWeight: 500, letterSpacing: "-0.02em", marginTop: "6px" }}>{v}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right column — photo */}
        <div className="hero-right" style={{ position: "relative" }}>
          {/* Technical overlay labels */}
          <div style={{ position: "absolute", inset: "32px", zIndex: 2, display: "flex", flexDirection: "column", justifyContent: "space-between", pointerEvents: "none" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span className="tech-label">FRAME · A-01</span>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <span className="tech-label">N 06°50' · E 79°55'</span>
            </div>
          </div>

          {/* Logo stamp */}
          <div style={{ position: "absolute", right: "32px", bottom: "32px", zIndex: 3, background: "#fff", border: "1px solid var(--ink)", padding: "12px 14px", display: "flex", flexDirection: "column", gap: "8px", width: "160px" }}>
            <img
              src={`${process.env.PUBLIC_URL}/logo-he-enterprises.png`}
              alt="HE Enterprises"
              style={{ width: "100%", height: "80px", objectFit: "contain", mixBlendMode: "multiply" }}
            />
            <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "9px", letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--muted)", borderTop: "1px solid var(--line)", paddingTop: "8px" }}>
              // Trusted since 2004
            </div>
          </div>

          {/* Hero image */}
          <div
            className="ph photo"
            style={{ height: "100%", "--photo": `url('${process.env.PUBLIC_URL}/hero.jpg?v=2')` }}
          >
          </div>
        </div>
      </div>
    </section>
  );
}
